import React from 'react';
import { View, type ViewProps } from 'react-native';
import { FadeInDown } from 'react-native-reanimated';
import { AnimatedView } from './animated';
import { Ionicons } from '@expo/vector-icons';
import { ThemedText } from '../themed-text';
import { Button } from './button';
import { cn } from '@/utils/cn';

export interface EmptyStateProps extends ViewProps {
  icon?: keyof typeof Ionicons.glyphMap;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  className?: string;
}

export function EmptyState({
  icon = 'document-outline',
  title,
  description,
  actionLabel,
  onAction,
  className,
  ...props
}: EmptyStateProps) {
  return (
    <AnimatedView
      entering={FadeInDown.springify().damping(18)}
      className={cn('items-center justify-center gap-4 p-8', className)}
      {...props}
    >
      <View
        className="h-16 w-16 items-center justify-center rounded-full bg-primary-50 dark:bg-primary"
        style={{ borderCurve: 'continuous' }}
      >
        <Ionicons className="text-primary dark:text-white" name={icon} size={28} />
      </View>
      <View className="items-center gap-1.5">
        <ThemedText className="text-center font-semibold text-lg text-foreground">
          {title}
        </ThemedText>
        {description && (
          <ThemedText className="max-w-sm text-center text-sm leading-5 text-neutral-500">
            {description}
          </ThemedText>
        )}
      </View>
      {actionLabel && onAction && <Button title={actionLabel} onPress={onAction} className="mt-1" />}
    </AnimatedView>
  );
}
